import { Link } from 'react-router-dom';
import { useState } from 'react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white shadow-lg py-3">
      <div className="w-full px-4 sm:px-6 lg:px-12">
        <div className="flex items-center justify-between">
          <Link className="flex items-center cursor-pointer hover:opacity-90 transition-opacity" to="/">
            <img
              alt="CX Comercializadora de Puebla"
              className="h-10 sm:h-12 w-auto transition-all duration-500"
              src="https://static.readdy.ai/image/44126011924ab97e0c4eb5476e9c701c/03ddab0fb09532e94d7645cd24b4fbb6.png"
            />
          </Link>
          
          <div className="hidden lg:flex items-center gap-6">
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/">
              Inicio
            </Link>
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/soluciones-empresas">
              Soluciones Empresas
            </Link>
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/catalogo">
              Catálogo
            </Link>
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/como-trabajamos">
              Cómo Trabajamos
            </Link>
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/nosotros">
              Nosotros
            </Link>
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/blog">
              Blog
            </Link>
            <Link className="text-sm font-medium transition-colors duration-300 cursor-pointer text-gray-700 hover:text-blue-700" to="/contacto">
              Contacto
            </Link>
          </div>
          
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="https://wa.me/+522228121142"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 hover:scale-105 transform"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Contactar por WhatsApp
            </a>
          </div>
          
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-3">
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/" onClick={() => setIsMenuOpen(false)}>
              Inicio
            </Link>
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/soluciones-empresas" onClick={() => setIsMenuOpen(false)}>
              Soluciones Empresas
            </Link>
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/catalogo" onClick={() => setIsMenuOpen(false)}>
              Catálogo
            </Link>
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/como-trabajamos" onClick={() => setIsMenuOpen(false)}>
              Cómo Trabajamos
            </Link>
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/nosotros" onClick={() => setIsMenuOpen(false)}>
              Nosotros
            </Link>
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/blog" onClick={() => setIsMenuOpen(false)}>
              Blog
            </Link>
            <Link className="block text-sm font-medium text-gray-700 hover:text-blue-700 py-2" to="/contacto" onClick={() => setIsMenuOpen(false)}>
              Contacto
            </Link>
            <a
              href="https://wa.me/+522228121142"
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-green-600 hover:bg-green-700 text-white px-6 py-2.5 rounded-lg text-sm font-semibold text-center"
            >
              <i className="ri-whatsapp-line text-lg mr-2"></i>
              Contactar por WhatsApp
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;